module.exports = __webpack_public_path__ + "img/walkthrough_illust31@2x.5a53a74f.png";